import { CoreBanner } from '@vitvio/design-system';
import { useConnectionStatus } from './graphql-connection-provider';

export function ConnectionLossBanner() {
  const { isConnected } = useConnectionStatus();

  return (
    <CoreBanner
      visible={!isConnected}
      type="error"
      titlePath="common:error.connectionLossTitle"
      descriptionPath="common:error.connectionLossDescription"
      icon="signal_wifi_off"
    />
  );
}
